// components/SheetsTable/ActionCell.jsx
import { useState } from "react";
import { IconButton, Menu, MenuItem, Box } from "@mui/material";
import { GridMoreVertIcon } from "@mui/x-data-grid";
import IconResolver from "../IconResolver";

const ActionCell = ({ params, actions }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const visibleActions = actions.filter((a) => a.isVisible?.(params.row));
  if (!visibleActions.length) return null;

  return (
    <>
      <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
        <GridMoreVertIcon fontSize="small" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {visibleActions.map((action, i) => (
          <MenuItem
            key={i}
            onClick={() => {
              action.onClick?.(params.row);
              setAnchorEl(null);
            }}
          >
            {action.label}
            {action.icon && (
              <Box
                ml="auto"
                pl={1} 
                display="flex"
                alignItems="center"
              >
                <IconResolver name={action.icon} size={18} />
              </Box>
            )}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ActionCell;
